import Header from "components/Headers/Header";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Button, Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { getPrePublicationSummaryById } from "utils/endpoint";
import useSearchParams from "utils/useSearchParams";

function ViewPrePublication() {
  const { state } = useLocation();
  const {id:view_pre_publication_id} = useParams();
  const [prePublicationQueryParams ,setPrePublicationQueryParams] = useSearchParams();
  const currentPage = prePublicationQueryParams.currentPage;
  const fromDate = prePublicationQueryParams.fromDate;
  const toDate = prePublicationQueryParams.toDate;
  const enTitle = prePublicationQueryParams.enTitle;
  const label = prePublicationQueryParams.label;
  const company = prePublicationQueryParams.company;
  const is_active = prePublicationQueryParams.is_active;
  const typeIdsArray = prePublicationQueryParams.typeIdsArray ? prePublicationQueryParams.typeIdsArray : [];
  const [prePublicationListData,setPrePublicationListData] = useState(state?.row ? state.row : []);
  const [prePublication,setPrePublication] = useState(prePublicationListData);
  const navigate = useNavigate()

  const handleSearchParams = (baseurl) => {
  const url = new URL(baseurl, window.location.origin);
  const params = new URLSearchParams(url.search);

  // Optional filters
  if (enTitle) params.set('en_title', enTitle);
  if (fromDate) params.set('from_date', fromDate);
  if (toDate) params.set('to_date', toDate);
  if (label) params.set('label', label);
  if (company) params.set('company', company);
  if (typeIdsArray && typeIdsArray.length > 0) {
    params.set('type_id', typeIdsArray.join(','));
  }

  if (is_active !== undefined) {
    const value =
      is_active === 'true'
        ? 'true'
        : is_active === 'none'
        ? 'none'
        : 'false';
    params.set('is_active', value);
  }

  url.search = params.toString();

  // Return relative URL
  return url.toString().replace(window.location.origin, '');
};


  const fetchPrePublicationDetail  = async () => {
    try {
      const response = await getPrePublicationSummaryById(view_pre_publication_id);
      if(response && response.isSuccess){
        setPrePublication(response.data)
      }
    } catch (error) {
      toast.error(`${error.message}`);
    }
  }

  useEffect(() => {
     if(!state){
      fetchPrePublicationDetail();
     }
  }, []);

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Card>
          <Row>
            <Col lg="7">
              <Card className="shadow m-4 detail_card">
                <CardHeader className="border-0">
                  <Row>
                  <Col lg="6">
                  <h1 className="mb-0">Pre-Publication Detail</h1>
                        </Col>
                        <Col lg="6" className="add_btn text-right">
                          <Button
                            color="primary"
                            className="m-2"
                            onClick={() => {
                              let baseURL = `/admin/prePublication/Prepublication-list?id=${prePublicationListData.id}&page=${currentPage}`;
                              const url = handleSearchParams(baseURL);
                              navigate(url);
                            }}>
                            <span className="me-2">Back</span>
                          </Button>
                        </Col>
                  </Row>
                </CardHeader>
                <CardBody className="custom-margin-top">
                  <Row>
                    {prePublication?.en_title ? (
                      <>
                        <Col lg="4">EN Title</Col>
                        <Col lg="8">
                          <div className="text-dark h2">
                            {prePublication.en_title}
                          </div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                  <Row className="mt-1">
                    {prePublication?.jp_title ? (
                      <>
                        <Col lg="4">JP Title</Col>
                        <Col lg="8">
                          <div className="text-dark">
                            {prePublication.jp_title}
                          </div>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>
                  {prePublication?.jp_name ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4">JP Name</Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {prePublication?.jp_name}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                  {prePublication?.jp_wikipedia ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4">JP Wikipedia</Col>
                        <Col lg="8">
                          <span className="text-dark">
                          <a href={prePublication?.jp_wikipedia} target="_blank" rel="noreferrer">
                            {prePublication?.jp_wikipedia?.length > 50 ? `${prePublication?.jp_wikipedia.slice(0, 40)}...` : prePublication?.jp_wikipedia}
                          </a>
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}

                  <Row className="mt-1">
                    {prePublication?.is_active || !prePublication?.is_active ? (
                      <>
                        <Col lg="4">Is Active</Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {prePublication?.is_active ? "Yes" : "No"}
                          </span>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                  </Row>

                  {prePublication?.created_at ? (
                    <>
                      <Row className="mt-1">
                        <Col lg="4">CreatedAt</Col>
                        <Col lg="8">
                          <span className="text-dark">
                            {prePublication.created_at
                              ? moment(prePublication.created_at).format(
                                  "YYYY-MM-DD HH:mm:ss"
                                )
                              : ""}
                          </span>
                        </Col>
                      </Row>
                    </>
                  ) : (
                    ""
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            {prePublication?.authors  ? (
              <Col lg="4">
                  <Card className=" shadow  m-4 view_cards">
                    <CardBody>
                      <h3 className="fw-bolder dot_border">Authors</h3>
                      <Col>
                        {prePublication.authors.map((author, index) => (
                          <li key={index}>{author.name}</li>
                        ))}
                      </Col>
                    </CardBody>
                  </Card>
              </Col>
            ) : (
             ""
            )}
           
            {prePublication?.authors  ? (
              <Col lg="2"></Col>
            ) : (
             ""
            )}

              {prePublication?.manga ? (
            <Col lg="4">
                <Card className="me-2 shadow  m-4 view_cards ">
                  <CardBody>
                    <h3 className="fw-bolder dot_border">Manga</h3>
                    <Col>
                      {prePublication?.manga?.map((manga) => (
                        <li key={manga.manga_id}>{manga.en_title}</li>
                      ))}
                    </Col>
                  </CardBody>
                </Card>
            </Col>
              ) : (
               ""
              )}
          </Row>
        </Card>
      </Container>
    </>
  );
}

export default ViewPrePublication;
